import React from "react";

import "./LoginFail.scss";
import { Block } from "@randajan/jet-react/dom/block";
import { Locale } from "../../../../assets/Locale";

const toCode = (rawCode)=>{
    const code = Number(rawCode);
    if (!Number.isInteger(code)) { return; }
    return code;
};

export const LoginFail = (props)=>{
    const { message, code } = props;
    const say = Locale.use();
    const errCode = toCode(code);
    const finalMessage = message || say("oauthLoginFailMessageFallback");

    return (
        <Block level={0} className="LoginFail" caption={say("oauthLoginFailCaption")}>
            <p className="desc">{say("oauthLoginFailDesc")}</p>
            <div className="details">
                {!errCode ? null : <p><span>{say("oauthLoginFailCodeLabel")}:</span> <strong>{errCode}</strong></p>}
                <p><span>{say("oauthLoginFailMessageLabel")}:</span> <strong>{finalMessage}</strong></p>
            </div>
            <p className="hint">{say("oauthLoginFailHint")}</p>
        </Block>
    );
};
